import { cacheFamilyLogin, getCachedFamilyLogin, getCachedFamilySession } from './cache';

const toBase64Url = (value) => {
  const raw = typeof value === 'string' ? value : JSON.stringify(value);
  try {
    return btoa(unescape(encodeURIComponent(raw)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/g, '');
  } catch (_) {
    return '';
  }
};

export function createOfflineLearnerToken({ learnerId, team = [], familyId = '' }) {
  const header = toBase64Url({ alg: 'none', typ: 'JWT' });
  const payload = toBase64Url({
    learner: learnerId,
    isFamily: true,
    team,
    familyId,
    flcOffline: true,
    iat: Math.floor(Date.now() / 1000),
  });
  return `${header}.${payload}.offline`;
}

export async function rememberOnlineFamilyLogin(result, usernames = []) {
  if (!result?.token) return;
  await cacheFamilyLogin({
    token: result.token,
    usernames: (usernames || []).filter(Boolean),
    familyId: result.familyId || null,
    familyMemberId: result.familyMemberId || null,
  });
}

export async function buildOfflineFamilyLogin(usernames = []) {
  const selected = (usernames || []).filter(Boolean).slice(0, 2);
  const remembered = await getCachedFamilyLogin();
  if (
    remembered?.token
    && JSON.stringify(remembered.usernames || []) === JSON.stringify(selected)
  ) {
    return {
      success: true,
      token: remembered.token,
      redirectTo: '/play',
      familyId: remembered.familyId || null,
      familyMemberId: remembered.familyMemberId || null,
      offline: true,
    };
  }

  const session = await getCachedFamilySession();
  const members = Array.isArray(session?.members) ? session.members : [];
  const orderedMembers = selected.map((username) => (
    members.find((member) => String(member?.username || '') === String(username || ''))
  ));

  if (!selected.length || orderedMembers.some((member) => !member)) {
    return { success: false, offline: true, error: 'This family login has not been downloaded for offline use.' };
  }

  const learner = orderedMembers[0];
  const team = orderedMembers.slice(1).map((member) => String(member._id || member.id || '')).filter(Boolean);
  const learnerId = String(learner?._id || learner?.id || '');
  if (!learnerId) return { success: false, offline: true, error: 'Offline learner profile is incomplete.' };

  const token = createOfflineLearnerToken({ learnerId, team, familyId: session?.familyId || session?.id || '' });
  await cacheFamilyLogin({
    token,
    usernames: selected,
    familyId: session?.familyId || session?.id || null,
    familyMemberId: learnerId,
    offline: true,
  });
  return {
    success: true,
    token,
    redirectTo: '/play',
    familyId: session?.familyId || session?.id || null,
    familyMemberId: learnerId,
    offline: true,
  };
}
